module.exports = __webpack_public_path__ + "img/artist-paint.d76f2d80.jpeg";